import React from 'react';
import { withTranslation } from 'react-i18next';
import {connect} from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import firebase,{ db, checkStorageLimit } from 'src/config/firebase';
// material ui
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import { Backdrop, Dialog, DialogActions, DialogContent, DialogTitle, Button, CircularProgress, Checkbox } from "@mui/material";
import { AddCircle } from '@mui/icons-material';
// components
import { convertHtmlToDeltaHelper } from 'src/components/Utils/TextEditor/hook';
import TextEditor from 'src/components/Utils/TextEditor/Editor';
import CompressImage from 'src/hooks/CompressImage';
import '../../assets/stylesheet/addcompany.css';
import theme from '../../config/theme.js';

const styles = theme => ({
    backdrop: {
        zIndex: 111125,
        color: '#fff',
        position:'absolute'
    },

    photoDiv:{
        alignSelf: 'center',
        position: 'relative',
        border: '1px solid #C4C4C4',
        width: '100px',
        height: '100px',
        minWidth: '100px',
        minHeight: '100px',
        borderRadius: '50px',
        margin: '10px 0px',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        cursor: 'pointer',
        "& span":{
            textTransform: 'capitalize',
            textAlign: 'center',
            color: '#0F467A',
            width:'100px',
            height:'100px',
            display:'flex',
            flexDirection:'column',
            justifyContent:'center',
            fontFamily: "'Poppins', sans-serif",
        },
        "& img":{
            width: '100%',
            height: '100%',
            borderRadius: '50px'
        },
        [theme.breakpoints.between('xs','md')]: {
            width: '80px',
            height: '80px',
        }
    },

    photoIcon:{
        position: 'absolute',
        bottom: '0px',
        right: '0px',
        color: '#0F467A',
    },
});

const ColorCircularProgress = withStyles({
    root: {
      color: '#0F467A',
    },
})(CircularProgress);

const StyleCheckbox = withStyles({
    root: {
      color: '#BDBDBD',
      '&$checked': {
        color: '#0F467A',
      },
    },
    checked: {},
})(props => <Checkbox color="default" {...props} />);

class AddCategoryDialog extends React.Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            avatarUrl:'',
            avatar:'',
            name:'',
            description: [],
            descriptionHtml:'',
            enable:true,
            message:'',
            open:false,

            dialogLoading:false,
            loading:false,
        };
        this.fileUploader = React.createRef();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;
        const { optionId, alertMessage } = this.props;
        if(optionId && this._isMounted) {
            this.setState({loading:true});
            db.ref(`PartnerCategories/${optionId}`).once('value',data => {
                const res = data.val();
                if(res) {
                    this.setEditState(res);
                    this.setState({loading:false});
                }
                else{
                    alertMessage('No Category found!','error');
                    this.setState({loading:false});
                }
            })
            .catch(e => {
                alertMessage(e.message,'error');
                this.setState({loading:false});
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        this._isMounted = true;
        const { alertMessage } = this.props;
        if(this.props.optionId !== prevProps.optionId && this._isMounted) {
            this.setState({loading:true});
            db.ref(`PartnerCategories/${this.props.optionId}`).once('value',data => {
                const res = data.val();
                if(res) {
                    this.setEditState(res);
                    this.setState({loading:false});
                }
                else{
                    alertMessage('No Option found!','error');
                    this.setState({loading:false});
                }
            })
            .catch(e => {
                alertMessage(e.message,'error');
                this.setState({loading:false});
            })
        }
    };

    // avatar input event
    handleOpenFile = () => {
        this.fileUploader.current.click();
    };

    // select avatar event
    uploadFile = async e  => { 
        this._isMounted = true;  
        if (e.target.files && e.target.files.length > 0) {
            let imageFile = e.target.files[0];
            let avatarUrl = URL.createObjectURL(imageFile);
            let compressFile = await CompressImage(imageFile);
            if(this._isMounted) this.setState({avatar:compressFile,avatarUrl});
        };
    };

    setEditState = data => {
        this.setState({
            name:data.name ?? '',
            description: data?.description ? convertHtmlToDeltaHelper(data?.description) : [],
            descriptionHtml: data?.description || '',
            enable: data.enable ?? false,
            avatarUrl: data.photo ?? ''
        });
    };

    generateId = () => { // generate random id for avatar to avoid overwrite in storage
        var result = '';
        var length = 15;
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
           result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    };

    handleClose = () => {
        this.resetState();
		this.props.onClose();
    };
    
    submit = async () => { // Add/Update Category
        this._isMounted = true;
        const { company, alertMessage, t, optionId } = this.props;
        let { name, description, descriptionHtml, enable, avatar, avatarUrl } = this.state;
        const companyId = company && company.id;
        if(companyId && name && this._isMounted) {
            this.setState({dialogLoading:true});
            const date = Math.floor(new Date().getTime()/1000);

            if(optionId) {
                const catObject = { description: descriptionHtml || '', name, enable, photo: avatarUrl };
                if(avatar){
                    try{
                        const { allowed, message } = await checkStorageLimit({companyId,fileSize: avatar?.size});
                        if(allowed) {
                            let storageRef = firebase.storage().ref().child(`${companyId}/Covers/Categories/${uuidv4()}`);
                            storageRef.put(avatar)
                            .then((url) =>{
                                url.ref.getDownloadURL()
                                .then((res) =>{ 
                                    catObject.photo = res
                                    db.ref(`PartnerCategories/${optionId}`).update(catObject).then(()=> {
                                        this.setState({dialogLoading:false},()=> {
                                            alertMessage(t("addCate.editSuc"),'success');
                                            this.resetState();
                                        })
                                    })
                                    .catch(e => {
                                        alertMessage(e.message,'error');
                                        this.setState({dialogLoading:false});    
                                        console.log('e',e)
                                    })
                                }).catch(e => {
                                    alertMessage(e.message,'error');
                                    this.setState({dialogLoading:false});
                                    console.log('e',e)
                                })
                            })
                            .catch(e => {
                                alertMessage(e.message,'error');
                                this.setState({dialogLoading:false});
                                console.log('e',e)
                            })
                        }
                        else if(!allowed && message) {
                            this.setState({dialogLoading:false});
                            alertMessage(message,'error');
                        }
                    }
                    catch(e){
                        this.setState({dialogLoading:false});
                        alertMessage(e,'error');
                    }
                }
                else{
                    db.ref(`PartnerCategories/${optionId}`).update(catObject).then(()=> {
                        setTimeout(()=> this.setState({dialogLoading:false},()=> alertMessage(t("addCate.editSuc"),'success')),1500);
                        this.resetState();
                    })
                    .catch(e => {
                        alertMessage(e.message,'error');
                        this.setState({dialogLoading:false});
                        console.log('e',e)
                    })
                }
            }
            else{
                var nodeId = (await db.ref('PartnerCategories').push()).key;

                const catObject = { date, companyId, description:descriptionHtml, name, enable, photo: avatarUrl, id: nodeId };
                if(avatar){
                    try{
                        const { allowed, message } = await checkStorageLimit({companyId,fileSize: avatar?.size});
                        if(allowed) {
                            let storageRef = firebase.storage().ref().child(`${companyId}/Covers/Categories/${uuidv4()}`);
                            storageRef.put(avatar)
                            .then((url) =>{
                                url.ref.getDownloadURL()
                                .then((res) =>{ 
                                    catObject.photo = res
                                    db.ref(`PartnerCategories/${nodeId}`).set(catObject).then(()=> {
                                        this.setState({dialogLoading:false},()=> {
                                            alertMessage(t("addCate.addedSuc"),'success');
                                            this.resetState();
                                        })
                                    })
                                    .catch(e => {
                                        alertMessage(e.message,'error');
                                        this.setState({dialogLoading:false});    
                                        console.log('e',e)
                                    })
                                }).catch(e => {
                                    alertMessage(e.message,'error');
                                    this.setState({dialogLoading:false});
                                    console.log('e',e)
                                })
                            })
                            .catch(e => {
                                alertMessage(e.message,'error');
                                this.setState({dialogLoading:false});
                                console.log('e',e)
                            })
                        }
                        else if(!allowed && message) {
                            this.setState({dialogLoading:false});
                            alertMessage(message,'error');
                        }
                    }
                    catch(e){
                        this.setState({dialogLoading:false});
                        alertMessage(e,'error');
                    }
                }
                else{
                    db.ref(`PartnerCategories/${nodeId}`).set(catObject).then(()=> {
                        setTimeout(()=> this.setState({dialogLoading:false},()=> alertMessage(t("addCate.addedSuc"),'success')),1500);
                        this.resetState();
                    })
                    .catch(e => {
                        alertMessage(e.message,'error');
                        this.setState({dialogLoading:false});
                        console.log('e',e)
                    })
                }
            }
        }
    };

    resetState = () => {
        this._isMounted = true;
        if(this._isMounted) {
            this.setState({
                name:'', description: [], descriptionHtml:'', enable:false, avatar:'',avatarUrl:'',dialogLoading:false},()=>{
                this.props.onClose();
            });
        };
    }

    onChangeHandle = e => {
        this._isMounted = true;
        let fieldName= e.target.id;
        let value = e.target.value;
        if(this._isMounted) {
            if(value === 'enable') {
                this.setState({enable:!this.state.enable})
            }
            else{
                this.setState({[fieldName]:value});
            }
        }
    };

    onChangeDesc = (fieldName,value,_,_html) => {
        this._isMounted = true;
        if(this._isMounted) {
            this.setState({[fieldName]:value,'descriptionHtml': _html});
        }
    };
    
    render() {
        let { t, i18n,tReady,dispatch,classes, alertMessage, optionId, ...other } = this.props;
        let {name, description, descriptionHtml, enable, dialogLoading, loading, avatar, avatarUrl } = this.state;
        const isRTL = i18n.translator.language;
        const ar = "'Cairo', sans-serif";
        const en = "'Poppins', sans-serif";
        const fontFamily = isRTL === 'ar' ? ar : en; 

	return (
        (<Dialog
          {...other}
          fullWidth={true}
          maxWidth="sm"
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          dir={isRTL === 'ar' ? 'rtl' : 'ltr'}
          style={{fontFamily}}
        >
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme}>
                <DialogTitle id="alert-dialog-title">{optionId ? t('addCate.title2') : t('addCate.title')}</DialogTitle>
                </ThemeProvider>
            </StyledEngineProvider>
            <DialogContent style={{display:'flex',flexDirection:'column'}}>

                {/* avatar section */}
                <input type="file" id="file" ref={this.fileUploader} onClick={(event)=> { event.target.value = null}}
                    style={{display: "none"}} accept="image/*" onChange={this.uploadFile}
                />
                <div className={classes.photoDiv} onClick={this.handleOpenFile}>
                    {avatar && avatarUrl ? 
                        <img src={avatarUrl} alt='logo'/>
                    :
                    optionId && avatarUrl ?
                        <img src={avatarUrl} alt='logo'/>
                    :
                    <span style={{fontFamily}}>{t('addCate.photo')}</span>
                    }
                    <AddCircle size='large' className={classes.photoIcon} />
                </div>

                <div className='activityTimePicker' style={{width:'100%'}}>
                    <span className='actloText' style={{fontFamily}}>{t('addCate.name')}</span>
                    <input type='text' placeholder={t('addCate.name')} id="name" value={name} style={{fontFamily}} onChange={this.onChangeHandle} className='textInputField' />
                </div>

                <div className='activityTimePicker' style={{width:'100%'}}>
                    <span className='actloText' style={{fontFamily}}>{t('addCate.desc')}</span>
                    {/* <span className={`${classes.label} ${classes.marTop}`} style={{fontFamily}}>{t('new_service.desc')}</span> */}
                    <TextEditor 
                        {...{
                            _stateValue: description,
                            _stateName:'description',
                            handleChange: this.onChangeDesc
                        }}
                    />
                </div>

                <div style={{width:'100%',display:'flex',flexDirection:'row',alignItems:'center'}}>
                <StyleCheckbox
                    checked={enable}
                    onChange={this.onChangeHandle}
                    value='enable'
                />
                <span className='actloText' style={{fontFamily,alignSelf:'center'}}>{t('addCate.enable')}</span>
                </div>

                {dialogLoading && 
                <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                    <ColorCircularProgress style={{alignSelf:'center',margin:'10px 0px'}}  disableShrink size={24}/>
                    <span style={{fontWeight:'bold',color:'#A8ABAD',marginLeft:'10px',fontFamily}}>{optionId ? t('renew.updating') : t('renew.adding')}</span>
                </div>
                }
            </DialogContent>
            <DialogActions>
                <Button color="inherit" onClick={this.handleClose} style={{fontFamily}}>
                {t('upgrade-dialog.can')}
                </Button>
                <Button 
                    onClick={this.submit}
                    style={{fontFamily}}
                    disabled={!name}
                    color="secondary" autoFocus>
                    {optionId ? t('accept-dialog.update') : t('comp-comp.save')}
                </Button>
            </DialogActions>
            <Backdrop className={classes.backdrop} open={loading}>
                <ColorCircularProgress disableShrink size={24} />
            </Backdrop>
        </Dialog>)
    );
    }
}

const mapStateToProps = state => {
    return{
        user : state.user,
        company: state.company,
    }
}

export default connect(mapStateToProps,null)(withTranslation('common')(withStyles(styles)(AddCategoryDialog)));